import { render, staticRenderFns } from "./list_leads.vue?vue&type=template&id=36d5db74&scoped=true"
import script from "./list_leads.vue?vue&type=script&lang=js"
export * from "./list_leads.vue?vue&type=script&lang=js"
import style0 from "./list_leads.vue?vue&type=style&index=0&id=36d5db74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5db74",
  null
  
)

/* custom blocks */
import block0 from "./list_leads.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports